export default __webpack_public_path__ + "static/og-preview-d6d16206a201aeaab57826ff6eac1067.jpg";